// frontend/src/components/MenuSanduiche.js
import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes, FaUser, FaSignOutAlt } from 'react-icons/fa';
import Logo from './Logo';

function MenuSanduiche({ 
  usuario, 
  pagina, 
  setPagina, 
  navigate, 
  handleLogout,
  menuItems = [] 
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [empresa, setEmpresa] = useState(null);
  const [loadingEmpresa, setLoadingEmpresa] = useState(true);

  useEffect(() => {
    // Buscar dados da empresa APENAS UMA VEZ
    if (usuario?.empresa_id) {
      setLoadingEmpresa(true);
      fetch(`/api/empresas/${usuario.empresa_id}`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      })
        .then(res => {
          if (res.ok) return res.json();
          throw new Error('Erro ao buscar empresa');
        })
        .then(data => {
          setEmpresa(data);
          setLoadingEmpresa(false);
        })
        .catch(err => {
          console.error('Erro ao buscar empresa:', err);
          setLoadingEmpresa(false);
        });
    } else {
      setLoadingEmpresa(false);
    }
  }, [usuario?.empresa_id]); // Só executa quando o empresa_id mudar

  return (
    <div style={{ position: 'relative' }}>
      {/* Botão do Menu */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          background: 'none',
          border: 'none',
          color: 'white',
          fontSize: '24px',
          cursor: 'pointer',
          padding: '8px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
        }}
      >
        {/* Logo - SEMPRE MOSTRAR, SEM PISCAR */}
        <div style={{ minWidth: '30px', minHeight: '30px' }}>
          <Logo 
            empresaId={usuario?.empresa_id} 
            size="small"
            showName={false}
          />
        </div>
        <FaBars />
      </button>

      {/* Overlay */}
      {isOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 999
          }}
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          bottom: 0,
          width: '300px',
          backgroundColor: '#1a1a2e',
          color: 'white',
          zIndex: 1000,
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',
          transition: 'transform 0.3s ease',
          overflowY: 'auto',
          boxShadow: '2px 0 10px rgba(0,0,0,0.3)'
        }}
      >
        {/* Cabeçalho do Menu */}
        <div style={{
          padding: '20px',
          borderBottom: '1px solid #333',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '10px'
        }}>
          <button
            onClick={() => setIsOpen(false)}
            style={{
              alignSelf: 'flex-end',
              background: 'none',
              border: 'none',
              color: 'white',
              fontSize: '20px',
              cursor: 'pointer'
            }}
          >
            <FaTimes />
          </button>

          {/* Logo Grande - SEM PISCAR */}
          <div style={{ minWidth: '80px', minHeight: '80px' }}>
            <Logo 
              empresaId={usuario?.empresa_id} 
              size="large"
              showName={false}
            />
          </div>

          {/* Nome da Empresa */}
          <div style={{ textAlign: 'center' }}>
            <h3 style={{ margin: '5px 0', color: 'white' }}>
              {loadingEmpresa ? 'Carregando...' : (empresa?.nome_fantasia || empresa?.nome_empresa || 'Minha Empresa')}
            </h3>
            <p style={{ margin: '2px 0', fontSize: '12px', color: '#adb5bd' }}>
              {loadingEmpresa ? '' : (empresa?.cnpj || '')}
            </p>
          </div>

          {/* Usuário */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            padding: '8px 15px',
            backgroundColor: 'rgba(255,255,255,0.05)',
            borderRadius: '20px',
            width: '100%'
          }}>
            <FaUser size={14} />
            <span style={{ fontSize: '13px' }}>
              {usuario?.nome_completo || usuario?.nome || 'Usuário'}
            </span>
          </div>
        </div>

        {/* Itens do Menu */}
        <div style={{ padding: '10px 0' }}>
          {menuItems.map((item) => (
            <button
              key={item.id}
              onClick={() => {
                setPagina(item.id);
                navigate(item.path);
                setIsOpen(false);
              }}
              style={{
                width: '100%',
                padding: '12px 20px',
                background: pagina === item.id ? 'rgba(0,123,255,0.2)' : 'none',
                border: 'none',
                color: pagina === item.id ? '#007bff' : '#adb5bd',
                cursor: 'pointer',
                textAlign: 'left',
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                borderLeft: pagina === item.id ? '3px solid #007bff' : 'none',
                transition: 'all 0.2s'
              }}
            >
              <span style={{ fontSize: '18px' }}>{item.label.split(' ')[0]}</span>
              {item.label}
            </button>
          ))}
        </div>

        {/* Botão Sair */}
        <div style={{
          padding: '10px 20px',
          borderTop: '1px solid #333',
          marginTop: 'auto'
        }}>
          <button
            onClick={() => {
              handleLogout();
              setIsOpen(false);
            }}
            style={{
              width: '100%',
              padding: '10px',
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              justifyContent: 'center',
              fontSize: '14px'
            }}
          >
            <FaSignOutAlt /> Sair
          </button>
        </div>
      </div>
    </div>
  );
}

export default MenuSanduiche;